// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__1QHmD","label":"Category_label__3_2R5","content":"Category_content__YEvyD","header":"Category_header__1vY6A","location":"Category_location__g07pV"};